"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Input;
(function (Input) {
    let UpdateRelationOperation;
    (function (UpdateRelationOperation) {
        UpdateRelationOperation["connect"] = "connect";
        UpdateRelationOperation["disconnect"] = "disconnect";
        UpdateRelationOperation["create"] = "create";
        UpdateRelationOperation["update"] = "update";
        UpdateRelationOperation["upsert"] = "upsert";
        UpdateRelationOperation["delete"] = "delete";
    })(UpdateRelationOperation = Input.UpdateRelationOperation || (Input.UpdateRelationOperation = {}));
    let CreateRelationOperation;
    (function (CreateRelationOperation) {
        CreateRelationOperation["connect"] = "connect";
        CreateRelationOperation["create"] = "create";
    })(CreateRelationOperation = Input.CreateRelationOperation || (Input.CreateRelationOperation = {}));
    let OrderDirection;
    (function (OrderDirection) {
        OrderDirection["asc"] = "asc";
        OrderDirection["desc"] = "desc";
    })(OrderDirection = Input.OrderDirection || (Input.OrderDirection = {}));
    let FieldMeta;
    (function (FieldMeta) {
        FieldMeta["readable"] = "readable";
        FieldMeta["updatable"] = "updatable";
    })(FieldMeta = Input.FieldMeta || (Input.FieldMeta = {}));
})(Input || (Input = {}));
exports.default = Input;
//# sourceMappingURL=input.js.map